<style>
.mondaiKLinkSet {
  color: #aec4cd!important;
  text-decoration: none!important;
  pointer-events: none!important;
}
</style>

<template>
  <table v-if="isLoaded" class="mdTable01 mdPcMb0">
    <colgroup>
      <col width="30%">
      <col width="70%">
    </colgroup>
    <tbody>
      <tr
        v-for="(category, categoryIndex) in computedCategories"
        :key="categoryIndex"
      >
        <th>
          <div v-html="category.name"></div>
          <p class="mdTxtUpdate01 mt5" v-html="$store.getters['status/displayAt'](category.status)"></p>
        </th>
        <td class="tal">
          <template v-if="isDump">
            <ul>
              <li
                v-for="link in category.links"
                :key="link.id"
                style="display: block; margin: 13px 0px;"
              >
                <label v-html="link.name" style="display: inline-block; color: inherit; line-height: inherit; margin-right: .5em;"></label>
                <div style="display: inline-block;">
                  (<template
                      v-for="(myLink, myLinkIndex) in link.myLinks"
                    ><a
                        :key="myLinkIndex"
                        :href="myLink.href"
                        style="display: inline-block; border: none; margin: 0px; padding: 0px;"
                        v-html="myLink.name"
                      ></a>{{myLinkIndex !== link.myLinks.length - 1 ? ' | ' : ''}}</template>)
                </div>
              </li>
            </ul>
            <p></p>
          </template>
          <template v-else>
            <ul class="mdBreadList02">
              <li
                v-for="link in category.links"
                :key="link.id"
                style="display: inline-block;"
              >
                <a
                  :href="link.href || void(0)"
                  :nohref="link.href ? void(0) : 'nohref'"
                  :class="{errorUrl: !link.href}"
                  v-html="link.name"
                ></a>
              </li>
            </ul>
          </template>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
const labelTable = {s1: '速報&#9313;', s3: '速報&#9314;'};

export default {
  data() {
    return {
      loadState: 'pending',
      links: {},
    }
  },

  computed: {
    filepath() { return this.$store.getters['path/$join']('resources', 'sokuhou/mondai_k/conf/links.json') },
    isLoaded() { return this.loadState === 'loaded' },
    isDump() { return this.$store.getters['config/envIs']('test') },
    computedCategories() {
      return this.categories.map(category => {
        return {
          name  : category.name,
          status: category.status,
          links : category.links.map(link => {
            const myData = this.links[link.id];
            const links = myData.links;
            const linkIsNothing = !!(links['s1'] === '' && links['s2'] === '' && links['s3'] === '');
            const href = myData.status === 'non' || linkIsNothing ? null : links[myData.status];
            const myLinks = [];
            for (let key in labelTable) {
              if (links[key]) {
                myLinks.push({name: labelTable[key], href: links[key]});
              }
            }
            return {
              name: link.name,
              id  : link.id,
              href: href,
              myLinks,
            }
          }),
        }
      });
    },
  },

  methods: {
    init() {
      this.load();
    },

    async load() {
      this.loadState = 'loading';
      const res = await this.$http.get(this.filepath);
      this.$set(this, 'links', res.data);
      this.setOuterVueLinks();
      this.loadState = 'loaded';
    },

    setOuterVueLinks() {
      const { links } = this;
      for (const key in links) {
        const data = links[key];
        const $link = $(`.mondaiKLinkSet[data-url_id="${key}"]`);
        if ($link.get(0)) {
          $link.removeClass('mondaiKLinkSet');
          if (data.status === 'non') {
            $link.attr('href', null);
            $link.attr('nohref', 'nohref');
            $link.addClass('errorUrl');
          }
        }
      }
    },
  },

  created() {
    this.init();
  },
}
</script>



// WEBPACK FOOTER //
// Table.vue?25ed21e0